import { Component } from '@angular/core';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface ContentViewBlock extends ContentBlock {
    blocks: ContentBlock[];
}

@Component({
    template: `<tyt-content-view [blocks]="block.blocks"></tyt-content-view>`
})
export class ViewComponent extends ContentBlockViewComponent<ContentViewBlock> {
}

@Component({
    template: `
        <tyt-content-editor [blocks]="block.blocks"></tyt-content-editor>
    `,
    styles: [`
        tyt-content-editor {
            display: block;
            margin: 1em;
        }
    `]
})
export class EditorComponent extends ContentBlockEditorComponent<ContentViewBlock> {
}

export const CONTENT_VIEW_BLOCK_TYPE: ContentBlockType<ContentViewBlock> = {
    id: 'content-view',
    label: 'Content View',
    icon: 'dashboard',
    template: {
        blocks: []
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
